import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { createNewRole } from "../services/routes";  // adjust import path

const CreateRoleButton = ({setCreateRole}) => {
  const [show, setShow] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOpen = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setRoleName("");
  };

  const handleSubmit = async () => {
    if (!roleName?.trim()) return;
    setLoading(true);
    try {
      await createNewRole({
        type: roleName?.trim(),
        permissions: [],
      });
      setCreateRole(true)
      handleClose(); // close modal on success
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Black Button */}
      <Button variant="dark" onClick={handleOpen}>
        Create Role
      </Button>

      {/* Modal Popup */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Create New Role</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Role Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter role name"
              value={roleName}
              onChange={(e) => setRoleName(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="dark" onClick={handleSubmit} disabled={loading}>
            {loading ? "Creating..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateRoleButton;
